export const data__profile_field_visibility = {
    'all-members': {
        'label': "All Members",
        "description": "Visible to all members of the community"
    },
    'followers-only': {
        'label': "Followers Only",
        "description": "Visible only to followers of the member"
    },
    'private': {
        'label': "Member & Admins",
        "description": "Visible only to the member and admins"
    },
    'admins-only': {
        'label': "Admins Only",
        "description": "Visible only to admins of the community"
    },
    'hidden': {
        'label': "Hidden",
        "description": "Hidden from view"
    },
};

export const data__profile_field_visibility_arr = Object.entries(data__profile_field_visibility).map(([k, v]) => {
    return {
        value: k,
        label: v.label,
    }
})